<template lang="pug">
.container-fluid.px-0
  .container-fluid.px-0.d-flex.justify-content-center
    img.img-fluid.deskImg(src="/static/activity/2023redenvelope/top.jpg")
    img.img-fluid.mobileImg(src="/static/activity/2023redenvelope/top-mobile.jpg")
  .container-fluid.px-0.d-flex.flex-column.justify-content-between.align-items-center.bodyBg.text-decoration-none
    .btn1
      a(href="https://reurl.cc/x1r7MV").d-flex.justify-content-center
        img(src="/static/activity/2023redenvelope/btn1.png")
    .row.redEnvelope.container.d-flex.my-5.justify-content-center
      .col-9.col-sm-7.col-md-6.col-xl-4.redEnv
        a(href="https://reurl.cc/x1r7MV")
          .redEnvDesc
            img(src="/static/activity/2023redenvelope/redEnv1text.png").img-fluid
            //- .redEnvText HAPPY2023
      .col-9.col-sm-7.col-md-6.col-xl-4.redEnv
        a(href="https://reurl.cc/x1r7MV")
          .redEnvDesc
            img(src="/static/activity/2023redenvelope/redEnv2text.png").img-fluid
            //- .redEnvText2 HAPPY100
      .col-9.col-sm-7.col-md-6.col-xl-4.redEnv
        a(href="https://reurl.cc/x1r7MV")
          .redEnvDesc
            img(src="/static/activity/2023redenvelope/redEnv3text.png").img-fluid.pt-4
            //- .redEnvText HAPPYCNY
    .method.container.d-flex.justify-content-center
      img(src="/static/activity/2023redenvelope/method.png").img-fluid
    .row.methodDesc.container.d-flex.my-5.justify-content-center.text-center
      .col-8.col-md-4.methodItem.method1.my-3.px-4
        img(src="/static/activity/2023redenvelope/method1.png").img-fluid
        p.mt-3.methodItemText 先準備好<br />編輯使用圖片或照片
      .col-8.col-md-4.methodItem.my-5.px-4
        img(src="/static/activity/2023redenvelope/method2.png").img-fluid
        p.mt-3.methodItemText 點選連結開始編輯
      .col-8.col-md-4.methodItem.my-5.px-4
        img(src="/static/activity/2023redenvelope/method3.png").img-fluid
        p.mt-3.methodItemText A.編輯完成於結帳頁面輸入兌換碼進行兌換<br /> B.無法一次完成，請選擇右上角存檔註冊會員後即可保存資料留待下次有空再進行編輯
    .btn2.mb-5
      a(href="https://reurl.cc/x1r7MV")
        img(src="/static/activity/2023redenvelope/btn2.jpg")
  .container-fluid.px-0.d-flex.justify-content-center.align-items-end.footerBg
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default{
  data () {
    return {
      activityId: null
    }
  },
  created () {
    this.activityId = this.$route.params.id
    let vm = this
    vm.getActivityProductItems()
  },
  computed: {
    ...mapState('activityModules', ['productItems', 'kind'])
  },
  methods: {
    ...mapActions('activityModules', ['getActivityProductItems'])
  },
  watch: {
    async '$route' (to, from) {
      const vm = this
      const id = to.params.id
      if (to.params.id !== from.params.id) {
        vm.activityId = id
      }
    }
  }
}
</script>
<style lang="scss" scoped>
//mobile
@media(max-width: 688px){
  .deskImg{
    display:none;
  }
  .mobileImg{
    display:initial;
    //display:flex;
  }
}
//desktop
@media(min-width: 688px){
  .deskImg{
    //display:initial;
    display:flex;
  }
  .mobileImg{
    display:none;
  }
}
.btn1{
  width: 40vw;
  margin: -6em;
  img{
    width: 100%;

  }
}
.btn2{
  width: 30vw;
  img{
    width: 100%;
  }
}
.bodyBg{
  .redEnv{
    width: 35vw;
  }
  .redEnvDesc{
    position: relative;
    text-align: center;
  }
  .redEnvText{
    position: absolute;
    top: 65%;
    left: 32%;
    font-size: 2rem;
    text-decoration: none;
    color: white;
  }
  .redEnvText2{
    position: absolute;
    top: 65%;
    left: 35%;
    font-size: 2rem;
    text-decoration: none;
    color: white;
  }
}
@media(max-width: 1270px){
  .redEnvDesc{
    position: relative;
    text-align: center;
  }
  .redEnvText{
    top: 70%;
    left: 39%;
  }
  .redEnvText2{
    top: 70%;
    left: 37%;
  }
}
@media(max-width: 1270px){
  .btn1{
    width: 50vw;
    margin: -2em;
  }
  .btn2{
    width: 50vw;
    }

}

@media(max-width: 688px){
  .bodyBg {
    /* The image used */
    background-image: url("/static/activity/2023redenvelope/mid-mobile-bg.jpg");

    /* Full height */
    // height: 2000px;

    /* Center and scale the image nicely */
    // background-position: center;
    background-repeat: repeat;
    background-size: contain;

    img{
      width:100%;
    }
    .redEnv{
      width: 30vw;
    }
    .redEnvDesc{
      position: relative;
      text-align: center;
    }
    .redEnvText{
      position: absolute;
      top: 70%;
      left: 42%;
      font-size: 1rem;
      text-decoration: none;
      color: white;
    }
    .redEnvText2{
      position: absolute;
      top: 70%;
      left: 41%;
      font-size: 1rem;
      text-decoration: none;
      color: white;
    }
    .methodItem{
      width: 30vw;
      img{
        width: 60%;
      }
    }
    .methodItem.method1 {
      img {
        width: 40%;
      }
    }
    .methodItemText{
      font-size: 1.3rem;
      font-weight: bold;
    }
  }
  .btn1{
    width: 90vw;
  }
  .btn2{
    width: 75vw;
    img{
      width: 100%;
    }
  }
}

@media(min-width: 688px){
  .bodyBg {
    /* The image used */
    background-image: url("/static/activity/2023redenvelope/mid.jpg");

    /* Full height */
    //width: 100%;
    //height: 100%;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: repeat;
    background-size: contain;

    img{
      width:100%;
    }
    .method{
      img{
        width: 45%;
      }
    }
    .methodItem.method1 {
      img {
        width: 50%;
      }
    }
    .methodItemText{
      font-size: 1.8rem;
      font-weight: bold;
    }

  }
}
@media(max-width: 688px){
  .footerBg {
    background-image: url("/static/activity/2023redenvelope/footer-mobile.jpg");
    height: 400px;

    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
@media(min-width: 688px){
  .footerBg {
    background-image: url("/static/activity/2023redenvelope/footer.jpg");
    height: 516px;

    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/activity.vue